import React from 'react'
import {observer} from 'mobx-react-lite'

import {useCompanyProjectsStore} from '../company-projects-store'
import {ProjectListBase} from './project-list-base'

export const CurrentProjectList = observer(() => {
  const [state, store] = useCompanyProjectsStore()

  return (
    <ProjectListBase
      projects={state.listProjects}
      maxCount={state.maxShowCurrentProjects}
      onMoreClick={store.showMoreCurrentProjects}
      canAddProjects
    />
  )
})
